import {
    useContext,
    type FC
} from "react";
import {
    Platform,
    View
} from "react-native";
import type ITimelineDayProps from "./type";
import type {
    TimelineDayWebPropsType
} from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    TimelinePartContentProps
} from "../../type";
import {
    getTimelineDayLabel,
    getTimelineDate
} from "../../util";
import {
    CardContext
} from "../../../card/context";
import {
    withTimelineContext
} from "../../context";
import Text from "../../../text";

const TimelineDayContent: FC<TimelinePartContentProps<ITimelineDayProps>> = ({
    customTheme: customThemeProp,
    context,
    style,
    date,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    const {
        controlHeights,
        shapeConfigs,
        borders,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(context.customLocalize);

    const cardContext = useContext(CardContext);

    const {
        container: containerDynamicStyle,
        line: lineDynamicStyle
    } = useStyles({
        isInCard: !!cardContext,
        controlHeights,
        shapeConfigs,
        borders,
        colors,
        spaces
    });

    const currentDate = getTimelineDate({
        value: date
    });

    if(!currentDate) {
        return null;
    }

    const webProps: TimelineDayWebPropsType = Platform.OS === "web" ? {
        "aria-level": 3
    } : {};

    return <View
        {...props}
        {...webProps}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        role="heading"
    >
        <Text
            customTheme={customTheme}
            variant="labelSmallSize"
            color="low"
        >
            {getTimelineDayLabel({
                locale: context.activeLocale,
                date: currentDate,
                now: context.now,
                localize
            })}
        </Text>
        <View
            style={[
                stylesheet.line,
                lineDynamicStyle
            ]}
            aria-hidden={true}
        />
    </View>;
};
export default withTimelineContext("Day", TimelineDayContent);
